function whatsInsidePill() 
{
    var pills               = document.querySelectorAll( ".pill_image" );
    var pill_main_image     = document.querySelector( ".pill_main_image" );
    var pill_title          = document.querySelector( ".pill_title");
    var pill_description    = document.querySelector( ".pill_description" );
    var pill_image_wrapper  = document.querySelectorAll( ".pill_image_wrapper" );
  
    function setActivePillData( activePill ) 
    {
        var pill_dataSrc          = activePill.getAttribute( 'src' );
        var pill_dataTitle        = activePill.getAttribute( 'data-title' );
        var pill_dataDescription  = activePill.getAttribute( 'data-description' );
    
        pill_main_image.setAttribute( 'src', pill_dataSrc );
        pill_title.innerHTML          = pill_dataTitle;
        pill_description.innerHTML    = pill_dataDescription;
        pill_main_image.classList.remove( 'hidden' );
    }
  
    pills.forEach(pill => 
    {
        pill.addEventListener( 'click', function() 
        {
            pill_image_wrapper.forEach( wrapper => 
            {
                wrapper.classList.remove( 'active' );
            });
    
            pill.closest( '.pill_image_wrapper' ).classList.add( 'active' );
            setActivePillData( pill );
        });
    });
  
    setActivePillData(document.querySelector( ".pill_image_wrapper.active .pill_image" ) );
  }


window.addEventListener( "load", function( e )
{ 
    whatsInsidePill();
} );